import React, { ReactNode } from "react"

interface ValueIfProps {
  value?: boolean
  expression?: ()=> boolean
  children: ReactNode
  otherwise?: ReactNode
}
const ValueIf: React.FC<ValueIfProps> = ({ value = false, expression = null, children, otherwise })=> {
  if (typeof expression === 'function') {
    value = expression()
  }

  return <>{ value ? children : otherwise }</>
}

export default ValueIf